import { DvcPage } from "navigation/DvcPage";
import { Energy }        from "pages/Details/Energy";
import { PAlarms } from "pages/Details/GCRAlarms";
import { PStages }       from "pages/Details/GCRStages";
import { PHarmonics }    from "pages/Details/Harmonics";
import { IOState }       from "pages/Details/IOState";
import { PMeasurements } from "pages/Details/Measurements";
import { POnline }       from "pages/Details/Online";
import { PUnitInfo }     from "pages/Details/UnitInfo";
import { PVector }       from "pages/Details/Vector";
import { POverview }     from "pages/Overview";
import { Route } from "react-router";


export const DvcPageList : DvcPage[] = [
  POverview,
  //PMeasurements,  // tohle je stejně jen další menu
  POnline,
  PHarmonics,
  PVector,
  Energy,
  IOState,
  PStages,
  PAlarms,
  PUnitInfo,
];

export const DvcPageRoutes =
  [DvcPageList, [PMeasurements]].flat(1).map((v, i) =>
    <Route path={v.path} exact key={i}>
      <v.page />
    </Route>
  )

